export var FieldType;
(function (FieldType) {
    FieldType[FieldType["Int"] = 1] = "Int";
    FieldType[FieldType["Decimal"] = 2] = "Decimal";
    FieldType[FieldType["Text"] = 3] = "Text";
    FieldType[FieldType["Selection"] = 4] = "Selection";
    FieldType[FieldType["DateTime"] = 5] = "DateTime";
    FieldType[FieldType["Boolean"] = 6] = "Boolean";
    FieldType[FieldType["Label"] = 7] = "Label";
    FieldType[FieldType["File"] = 8] = "File";
    FieldType[FieldType["DateOnly"] = 9] = "DateOnly";
    FieldType[FieldType["PhoneNumber"] = 10] = "PhoneNumber";
    FieldType[FieldType["Email"] = 11] = "Email";
    //Time = 12 (Not implemented)
    FieldType[FieldType["MultiSelection"] = 14] = "MultiSelection";
})(FieldType || (FieldType = {}));
export var FieldValueType;
(function (FieldValueType) {
    FieldValueType[FieldValueType["ListOfStrings"] = 1] = "ListOfStrings";
})(FieldValueType || (FieldValueType = {}));
